"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Staking = void 0;
const internal_1 = require("../../../../internal");
const conversion_1 = require("../../../../utils/conversion");
/**
 * Handles Account staking related functionality
 */
class Staking extends internal_1.Namespace {
    /**
     * Fetch the ledger information for a stash account
     *
     * @returns null unless the account is a controller
     */
    getLedger() {
        return __awaiter(this, void 0, void 0, function* () {
            const { context, context: { polymeshApi: { query }, }, } = this;
            const rawAddress = (0, conversion_1.stringToAccountId)(this.parent.address, context);
            const rawEntry = yield query.staking.ledger(rawAddress);
            if (rawEntry.isNone) {
                return null;
            }
            return (0, conversion_1.rawStakingLedgerToStakingLedgerEntry)(rawEntry.unwrap(), context);
        });
    }
    // eslint-disable-next-line require-jsdoc
    getPayee(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const { context, context: { polymeshApi: { query }, }, } = this;
            const rawAddress = (0, conversion_1.stringToAccountId)(this.parent.address, context);
            const assembleResult = (rawPayee, controller) => {
                if (!controller) {
                    return null;
                }
                return (0, conversion_1.rewardDestinationToPayee)(rawPayee, this.parent, controller, context);
            };
            if (callback) {
                let controller;
                const contUnsub = yield this.getController(newController => {
                    controller = newController;
                });
                const payeeUnsub = yield query.staking.payee(rawAddress, rawPayee => {
                    const result = assembleResult(rawPayee, controller);
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    callback(result);
                });
                return () => {
                    contUnsub();
                    payeeUnsub();
                };
            }
            const [rawPayee, controller] = yield Promise.all([
                query.staking.payee(rawAddress),
                this.getController(),
            ]);
            return assembleResult(rawPayee, controller);
        });
    }
    // eslint-disable-next-line require-jsdoc
    getNomination(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const { context, context: { polymeshApi: { query }, }, parent: { address }, } = this;
            const rawAddress = (0, conversion_1.stringToAccountId)(address, context);
            const assembleResult = (rawNomination) => {
                if (rawNomination.isNone) {
                    return null;
                }
                return (0, conversion_1.rawNominationToStakingNomination)(rawNomination.unwrap(), context);
            };
            if (callback) {
                this.context.assertSupportsSubscription();
                const unsub = query.staking.nominators(rawAddress, rawNomination => {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- callback errors should be handled by the caller
                    callback(assembleResult(rawNomination));
                });
                return unsub;
            }
            const rawNomination = yield query.staking.nominators(rawAddress);
            return assembleResult(rawNomination);
        });
    }
    // eslint-disable-next-line require-jsdoc
    getController(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const { context, context: { polymeshApi: { query }, }, } = this;
            const rawId = (0, conversion_1.stringToAccountId)(this.parent.address, context);
            const assembleResult = (controllerIdOpt) => {
                if (controllerIdOpt.isNone) {
                    return null;
                }
                const address = (0, conversion_1.accountIdToString)(controllerIdOpt.unwrap());
                return new internal_1.Account({ address }, context);
            };
            if (callback) {
                this.context.assertSupportsSubscription();
                const unsub = query.staking.bonded(rawId, rawController => {
                    const result = assembleResult(rawController);
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    callback(result);
                });
                return unsub;
            }
            const rawController = yield query.staking.bonded(rawId);
            return assembleResult(rawController);
        });
    }
    /**
     * @returns null unless the account is seeking nominations as a validator
     */
    getCommission() {
        return __awaiter(this, void 0, void 0, function* () {
            const { context, context: { polymeshApi: { query }, }, parent: { address }, } = this;
            const rawAddress = (0, conversion_1.stringToAccountId)(address, context);
            const rawValidator = yield query.staking.validators(rawAddress);
            if (rawValidator.isEmpty) {
                return null;
            }
            const commission = (0, conversion_1.rawValidatorPrefToCommission)(rawValidator);
            return Object.assign({ account: this.parent }, commission);
        });
    }
}
exports.Staking = Staking;
//# sourceMappingURL=index.js.map